import { ref, onUnmounted } from 'vue'

type SpeechRecognitionEvent = {
  results: SpeechRecognitionResultList
}

const SpeechRecognitionAPI =
  (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition

export function useSpeechRecognition(lang = 'fr-FR') {
  const isListening = ref(false)
  const isSupported = !!SpeechRecognitionAPI

  let recognition: any = null

  function start(onResult: (transcript: string) => void) {
    if (!isSupported || isListening.value) return

    recognition = new SpeechRecognitionAPI()
    recognition.lang = lang
    recognition.interimResults = false
    recognition.maxAlternatives = 1

    recognition.onstart = () => {
      isListening.value = true
    }

    recognition.onresult = (event: SpeechRecognitionEvent) => {
      const transcript = event.results[0][0].transcript
      onResult(transcript)
    }

    recognition.onerror = () => {
      isListening.value = false
    }

    recognition.onend = () => {
      isListening.value = false
    }

    recognition.start()
  }

  function stop() {
    recognition?.stop()
    isListening.value = false
  }

  onUnmounted(() => {
    recognition?.abort()
  })

  return { isListening, isSupported, start, stop }
}
